import axios from "axios";
import { API_URL, DEHASH_API_URL } from "../utils/constant";
// import Cookies from "universal-cookie";
import {
  LEAKEDCREDS_REQUESTS_FETCHED,
  LEAKEDCREDS_REQUESTS_FETCHED_TOTAL,
  LEAKEDCREDS_REQUESTS_FETCHED_GRAPH,
  TELEGRAM_REQUESTS_FETCHED,
  TELEGRAM_REQUESTS_FETCHED_GRAPH,
  GET_POST_MAN,
  MALWARE_CREDENTIALS_FETCHED,
  LEAKED_SESSION_FETCHED,
  GET_PHISHING_PAGE,
  PII_DETAILS,
  MALWARE_CREDENTIALS_FETCHED_TOTAL,
  MALWARE_CREDENTIALS_FETCHED_GRAPH,
  PII_DETAILS_TOTAL,
  PII_DETAILS_GRAPH,
  LEAKED_SESSION_FETCHED_GRAPH,
  TELEGRAM_REQUESTS_FETCHED_TOTAL,
  GET_POST_MAN_DETAILS,
  GET_POST_MAN_GRAPH,
  GET_POST_MAN_TOTAL,
  VIP_ENTITES,
  VIP_ENTITES_GRAPH,
  VIP_ENTITES_TOTAL
} from "./index";
import { toastr } from "react-redux-toastr";

export const fetchLeakedCredentials = (
  props,
  dispatch,
  page,
  category,
  type,
  emailquery,
  domainSelected,
  domains,
  startDate,
  endDate,
  limit,
  pwdLength
) => {
  if (props) {
    let url = `${API_URL}/dehashed/search/${props}/delta?page=${page}&limit=${limit}&category=${category}&type=${type}&emailquery=${emailquery}&from=${startDate}&till=${endDate}`;
    if (domainSelected === 'true' || domainSelected === 'all') {
      url += `&compromiseEmployee=${domainSelected}`;
    } else if (domainSelected && domains) {
      url += `&${domainSelected}=${domains}`;
    }
    if (pwdLength && pwdLength !== '') {
      url += `&pwd=${pwdLength}`;
    }
    axios.get(url)
      .then((res) => {
        dispatch({
          type: LEAKEDCREDS_REQUESTS_FETCHED,
          payload: res.data,
        });
      })
      .catch((error) => {
        // console.error removed
      });
  }
};

export const fetchLeakedCredentialsAction = (
  props,
  dispatch,
  page,
  category,
  type,
  emailquery,
  data
) => {
  if (props) {
    axios
      .post(
        `${API_URL}/dehashed/search/${props}/action?page=${page}&category=${category}&type=${type}&emailquery=${emailquery}`,
        data
      )
      .then((res) => {
        dispatch({
          type: LEAKEDCREDS_REQUESTS_FETCHED,
          payload: res.data,
        });
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const fetchLeakedCredentialsGraph = (props, dispatch) => {
  if (props) {
    axios.get(`${API_URL}/dehashed/search/${props}/graph`).then((res) => {
      dispatch({
        type: LEAKEDCREDS_REQUESTS_FETCHED_GRAPH,
        payload: res.data,
      });
    });
  }
};

export const leakedCredentialsUpdate = (props, dispatch, data, clear) => {
  if (props) {
    axios.patch(`${API_URL}/dehashed/search/${props}/update`, data).then((res) => {
      if (res.data.status == 200) {
        toastr.success("Success", res.data.userMessage);
        fetchLeakedCredentials(props, dispatch, 1, 'all', '', '', '', '', '', '');
        clear()
      } else {
        toastr.error("Error", res.data.userMessage);
      }
    });
  }
};

export const leakedCredentialsDelete = (props, dispatch, id) => {
  if (props) {
    axios.delete(`${API_URL}/dehashed/search/${props}/${id}/delete`).then((res) => {
      if (res.data.status == 200) {
        toastr.success("Success", res.data.userMessage);
        fetchLeakedCredentials(props, dispatch, 1, 'all', '', '', '', '', '', '');
      } else {
        toastr.error("Error", res.data.userMessage);
      }
    });
  }
};

export const fetchLeakedCredentialsTotal = (props, dispatch) => {
  if (props) {
    axios.get(`${API_URL}/dehashed/search/${props}/totals`, {}).then((res) => {
      dispatch({
        type: LEAKEDCREDS_REQUESTS_FETCHED_TOTAL,
        payload: res.data,
      });
    });
  }
};

export const telegram = (props, dispatch, page, category, startDate, endDate, limit) => {
  if (props) {
    axios.get(`${API_URL}/telegram-monitoring/${props}/delta?page=${page}&limit=${limit}&category=${category}&from=${startDate}&till=${endDate}`,).then((res) => {
      dispatch({
        type: TELEGRAM_REQUESTS_FETCHED,
        payload: res.data,
      });
    });
  }
};

export const telegramGraph = (props, dispatch) => {
  if (props) {
    axios.get(`${API_URL}/telegram-monitoring/${props}/graph`).then((res) => {
      dispatch({
        type: TELEGRAM_REQUESTS_FETCHED_GRAPH,
        payload: res.data,
      });
    });
  }
};

export const telegramDelete = (props, dispatch, id) => {
  if (props) {
    axios.delete(`${API_URL}/telegram-monitoring/${props}/${id}/delete`,).then((res) => {
      if (res.data.status == 200) {
        toastr.success("Success", res.data.userMessage);
        telegram(props, dispatch, 1, 'all', '', '')
      } else {
        toastr.error("Error", res.data.userMessage);
      }
    });
  }
};

export const telegramUpdate = (props, dispatch, data, clear) => {
  if (props) {
    axios.patch(`${API_URL}/telegram-monitoring/${props}/update`, data).then((res) => {
      if (res.data.status == 200) {
        toastr.success("Success", res.data.userMessage);
        clear()
        telegram(props, dispatch, 1, 'all', '', '')
      } else {
        toastr.error("Error", res.data.userMessage);
      }
    });
  }
};

export const vipEntitiesGet = (props, dispatch, page, limit) => {
  if (props) {
    axios.get(`${API_URL}/organisations/${props}/vip-entities/comprehensive-threat-alerts?page=${page}&limit=${limit}`,).then((res) => {
      dispatch({
        type: VIP_ENTITES,
        payload: res.data,
      });
    });
  }
};

export const vipEntitiesGraph = (props, dispatch, page) => {
  if (props) {
    axios.get(`${API_URL}/organisations/${props}/vip-entities/comprehensive-threat-alerts/graph`,).then((res) => {
      dispatch({
        type: VIP_ENTITES_GRAPH,
        payload: res.data,
      });
    });
  }
};

export const vipEntitiesTotal = (props, dispatch) => {
  if (props) {
    axios.get(`${API_URL}/organisations/${props}/vip-entities/comprehensive-threat-alerts/totals`,).then((res) => {
      dispatch({
        type: VIP_ENTITES_TOTAL,
        payload: res.data,
      });
    });
  }
};


export const telegramTotal = (props, dispatch) => {
  if (props) {
    axios.get(`${API_URL}/telegram-monitoring/${props}/totals`,).then((res) => {
      dispatch({
        type: TELEGRAM_REQUESTS_FETCHED_TOTAL,
        payload: res.data,
      });
    });
  }
};

export const telegramPost = (props, clear) => {
  if (props) {
    axios.post(`${API_URL}/telegram-monitoring`, props).then((res) => {
      if (res.data.status == 200) {
        clear()
        toastr.success("Success", res.data.userMessage);
        window.location.href = `/show-details/${props.organisationId}?tab=telegram`;
      } else {
        toastr.error("Error", res.data.userMessage);
      }
    });
  }
};


export const telegramAction = (props, dispatch, page, category, data, limit) => {
  if (props) {
    axios.post(`${API_URL}/telegram-monitoring/${props}/action?page=${page}&category=${category}&limit=${limit}`, data).then((res) => {
      dispatch({
        type: TELEGRAM_REQUESTS_FETCHED,
        payload: res.data,
      });
      if (res.data.status == 200) {
        toastr.success("Success", res.data.userMessage);
      } else {
        toastr.error("Error", res.data.userMessage);
      }
    });
  }
};


export const fetchMalwareCredentials = (
  props,
  dispatch,
  page,
  category,
  userquery,
  domainSelected,
  domains,
  startDate,
  endDate,
  limit,
  sortByFnd,
  pwdLength,
  workingCredentials
) => {
  if (props) {
    let url = `${API_URL}/getMalwareCredentials/${props}/delta?page=${page}&limit=${limit}&category=${category}&userquery=${userquery}&from=${startDate}&till=${endDate}`;
    if (domainSelected === 'true' || domainSelected === 'all') {
      url += `&compromiseEmployee=${domainSelected}`;
    } else if (domainSelected && domains) {
      url += `&filterSrcDomain=${domains}&filterUsrDomain=${domains}`;
    }
    // Always include sortByFnd parameter, default to 'desc' if not provided or invalid
    const sortValue = (sortByFnd === 'asc' || sortByFnd === 'desc') ? sortByFnd : 'desc';
    url += `&sortByFnd=${sortValue}`;
    if (pwdLength && pwdLength !== '') {
      url += `&pwd=${pwdLength}`;
    }
    if (workingCredentials !== '' && workingCredentials !== null && workingCredentials !== undefined) {
      url += `&workingCredentials=${workingCredentials}`;
    }
    axios.get(url)
      .then((res) => {
        dispatch({
          type: MALWARE_CREDENTIALS_FETCHED,
          payload: res.data,
        });
      })
      .catch((error) => {
        // console.error removed
      });
  }
};





// export const fetchMalwareCredentials = (props, dispatch, page, category, userquery, domainSelected, domains) => {
//   if (props) {
//     // Construct the base URL
//     const url = new URL(`${API_URL}/getMalwareCredentials/${props}/delta`);

//     // Create a URLSearchParams instance and add the fixed query parameters
//     const params = new URLSearchParams({
//       page,
//       category,
//       userquery,
//     });

//     // Conditionally add the domainSelected and domains parameters
//     if (domainSelected && domains) {
//       params.append(domainSelected, domains);
//     }

//     // Set the search parameters on the URL
//     url.search = params.toString();

//     // Make the GET request
//     axios.get(url.toString())
//       .then((res) => {
//         dispatch({
//           type: MALWARE_CREDENTIALS_FETCHED,
//           payload: res.data,
//         });
//       })
//       .catch((error) => {
//         // Handle any errors
//         // console.error removed
//       });
//   }
// };

export const fetchMalwareCredentialsAction = (props, dispatch, page, category, userquery, data) => {
  if (props) {
    axios
      .post(`${API_URL}/getMalwareCredentials/${props}/action?page=${page}&category=${category}&userquery=${userquery}`, data)
      .then((res) => {
        dispatch({
          type: MALWARE_CREDENTIALS_FETCHED,
          payload: res.data,
        });
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const malwareCredentialsUpdate = (props, dispatch, data, clear, malwarePage) => {
  if (props) {
    axios
      .patch(`${API_URL}/getMalwareCredentials/${props}/update`, data)
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
          clear()
          fetchMalwareCredentials(props, dispatch, malwarePage, 'all', '', '', '', '', '', 'desc')
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const malwareCredentialsDelete = (orgId, props, dispatch) => {
  if (props) {
    axios
      .delete(`${API_URL}/getMalwareCredentials/${orgId}/${props}/delete`)
      .then((response) => {
        if (response.data.status == 200) {
          fetchMalwareCredentials(orgId, dispatch, 1, 'all', '', '', '', '', '', 'desc')
          toastr.success("Success", response.data.userMessage);
        } else {
          toastr.error("Error", response.data.userMessage);
        }
      })
  }
};

export const malwareCredentialsBulkDelete = (orgId, ids) => {
  return new Promise((resolve, reject) => {
    axios.delete(`${API_URL}/api/getMalwareCredentials/${orgId}/bulkdelete`, { data: { ids } })
      .then(response => {
        if (response.data.status === 200) {
          toastr.success("Success", response.data.userMessage || "Malware credentials deleted successfully");
        } else {
          toastr.error("Error", response.data.userMessage || "Failed to delete malware credentials");
        }
        resolve(response.data);
      })
      .catch(error => {
        toastr.error("Error", "Failed to delete malware credentials");
        reject(error);
      });
  });
};

export const fetchMalwareCredentialsTotal = (props, dispatch) => {
  if (props) {
    axios
      .get(`${API_URL}/getMalwareCredentials/${props}/totals`, {})
      .then((res) => {
        dispatch({
          type: MALWARE_CREDENTIALS_FETCHED_TOTAL,
          payload: res.data,
        });
      });
  }
};

export const fetchMalwareCredentialsupdate = (props, dispatch, data, clear) => {
  if (props) {
    axios
      .get(`${API_URL}/getMalwareCredentials/${props}/update`, data)
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
          fetchMalwareCredentials(props, dispatch, 1, 'all', '', 'all', '', '', '', 'desc')
          clear()
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const fetchMalwareCredentialsGraph = (props, dispatch) => {
  if (props) {
    axios
      .get(`${API_URL}/getMalwareCredentials/${props}/graph`, {})
      .then((res) => {
        dispatch({
          type: MALWARE_CREDENTIALS_FETCHED_GRAPH,
          payload: res.data,
        });
      });
  }
};


export const fetchLeakedSession = (
  props,
  dispatch,
  page,
  status,
  name,
  category,
  domainSelected,
  domains,
  startDate,
  endDate,
  limit
) => {
  if (props) {
    let url = `${API_URL}/leaked-sessions/${props}/delta?page=${page}&limit=${limit}&status=${status}&name=${name}&category=${category}&from=${startDate}&till=${endDate}`;
    if (domainSelected && domains) {
      url += `&${domainSelected}=${domains}`;
    }
    axios.get(url)
      .then((res) => {
        dispatch({
          type: LEAKED_SESSION_FETCHED,
          payload: res.data,
        });
      })
      .catch((error) => {
        // console.error removed
      });
  }
};


export const fetchLeakedSessionAction = (props, dispatch, page, status, name, category, data) => {
  if (props) {
    axios
      .post(`${API_URL}/leaked-sessions/${props}/action?page=${page}&status=${status}&name=${name}&category=${category}`, data)
      .then((res) => {
        dispatch({
          type: LEAKED_SESSION_FETCHED,
          payload: res.data,
        });
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const fetchLeakedSessionGraph = (props, dispatch) => {
  if (props) {
    axios
      .get(`${API_URL}/leaked-sessions/${props}/graph`,)
      .then((res) => {
        dispatch({
          type: LEAKED_SESSION_FETCHED_GRAPH,
          payload: res.data,
        });
      });
  }
};



export const fetchPhishingPage = (props, dispatch) => {
  if (props) {
    axios.get(`${API_URL}/getPhishingPage/${props}`, {}).then((res) => {
      dispatch({
        type: GET_PHISHING_PAGE,
        payload: res.data,
      });
    });
  }
};

export const fetchPiiDetails = (props, dispatch, page, category, email_search_query, startDate, endDate, limit) => {
  if (props) {
    axios
      .get(`${API_URL}/pii-details/${props}/delta?page=${page}&limit=${limit}&category=${category}&email_search_query=${email_search_query}&from=${startDate}&till=${endDate}`)
      .then((res) => {
        dispatch({
          type: PII_DETAILS,
          payload: res.data,
        });
      });
  }
};

export const piiDelete = (props, dispatch, id) => {
  if (props) {
    axios
      .delete(`${API_URL}/pii-details/${props}/${id}/delete`)
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
          fetchPiiDetails(props, dispatch, 1, 'all', '', '', '')
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const piiUpdateById = (props, dispatch, data, clear, piipage) => {
  if (props) {
    axios
      .patch(`${API_URL}/pii-details/${props}/update`, data)
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
          fetchPiiDetails(props, dispatch, piipage, 'all', '', '', '')
          clear()
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const fetchPiiDetailsTotal = (props, dispatch) => {
  if (props) {
    axios
      .get(`${API_URL}/pii-details/${props}/totals`)
      .then((res) => {
        dispatch({
          type: PII_DETAILS_TOTAL,
          payload: res.data,
        });
      });
  }
};

export const fetchPiiDetailsGraph = (props, dispatch) => {
  if (props) {
    axios
      .get(`${API_URL}/pii-details/${props}/graph`)
      .then((res) => {
        dispatch({
          type: PII_DETAILS_GRAPH,
          payload: res.data,
        });
      });
  }
};

export const fetchPiiDetailsAction = (props, dispatch, page, category, email_search_query, data) => {
  if (props) {
    axios
      .post(`${API_URL}/pii-details/${props}/action?page=${page}&category=${category}&email_search_query=${email_search_query}`, data)
      .then((res) => {
        dispatch({
          type: PII_DETAILS,
          payload: res.data,
        });
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
        } else {
          toastr.success("Error", res.data.userMessage);
        }
      });
  }
};

export const PostMan = (props, dispatch) => {
  if (props) {
    axios.get(`${API_URL}/postmanRecord/${props}`, {}).then((res) => {
      dispatch({
        type: GET_POST_MAN,
        payload: res.data,
      });
    });
  }
};

export const postManDelta = (props, dispatch, page, category, startDate, endDate, limit, search, keyword) => {
  if (props) {
    let url = `${API_URL}/postmanRecord/${props}?page=${page}&limit=${limit}&category=${category}&from=${startDate}&till=${endDate}&search=${search}`;
    if (keyword && keyword !== 'all') {
      url += `&keyword=${keyword}`;
    }
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_POST_MAN,
          payload: response.data,
        });
      })
  }
};

export const postManAction = (props, dispatch, page, data, category, limit, search, keyword) => {
  if (props) {
    let url = `${API_URL}/postmanRecord/${props}/action?page=${page}&category=${category}&limit=${limit}&search=${search}`;
    if (keyword && keyword !== 'all') {
      url += `&keyword=${keyword}`;
    }
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: GET_POST_MAN,
          payload: response.data,
        });
        if (response.data.status == 200) {
          toastr.success("Success", response.data.userMessage);
        } else {
          toastr.success("Error", response.data.userMessage);
        }
      })
  }
};

export const postManGraph = (props, dispatch) => {
  if (props) {
    axios
      .get(`${API_URL}/postmanRecord/${props}/graph`)
      .then((response) => {
        dispatch({
          type: GET_POST_MAN_GRAPH,
          payload: response.data,
        });
      })
  }
};

export const postManTotal = (props, dispatch) => {
  if (props) {
    axios
      .get(`${API_URL}/postmanRecord/${props}/totals`)
      .then((response) => {
        dispatch({
          type: GET_POST_MAN_TOTAL,
          payload: response.data,
        });
      })
  }
};

export const PostManDetails = (props, id, dispatch) => {
  if (props) {
    axios.get(`${API_URL}/postmanRecordDetail/${props}?organisationId=${id}`, {}).then((res) => {
      dispatch({
        type: GET_POST_MAN_DETAILS,
        payload: res.data,
      });
    });
  }
};

export const addLeakedSession = (id, props) => {
  if (props) {
    axios.post(`${API_URL}/leakedsession/${id}`, props.data, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage || "Leaked session added successfully");
          if (props.callback) {
            props.callback();
          }
        } else {
          toastr.error("Error", res.data.userMessage || "Failed to add leaked session");
        }
      })
      .catch((error) => {
        toastr.error("Error", "Failed to add leaked session");
        // console.error removed
      });
  }
};

export const updateLeakedSession = (orgId, sessionId, sessionData, callback) => {
  if (!orgId || !sessionId || !sessionData) {
    toastr.error("Error", "Organization ID, session ID, and session data are required");
    return;
  }

  axios.put(`${API_URL}/organisations/${orgId}/leaked-sessions/${sessionId}`, sessionData, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then((res) => {
      if (res.data.status === 200 || res.status === 200) {
        toastr.success("Success", res.data.userMessage || "Leaked session updated successfully");
        if (callback) {
          callback();
        }
      } else {
        toastr.error("Error", res.data.userMessage || "Failed to update leaked session");
      }
    })
    .catch((error) => {
      let errorMessage = "Failed to update leaked session";

      if (error.response) {
        if (error.response.data?.userMessage) {
          errorMessage = error.response.data.userMessage;
        } else if (error.response.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.status === 400) {
          errorMessage = "Invalid data provided. Please check your input.";
        } else if (error.response.status === 404) {
          errorMessage = "Leaked session not found.";
        } else if (error.response.status === 500) {
          errorMessage = "Server error. Please try again later.";
        }
      } else if (error.request) {
        errorMessage = "Network error. Please check your connection.";
      }

      toastr.error("Error", errorMessage);
      // console.error removed
    });
};

export const deleteLeakedSession = (orgId, sessionId, callback) => {
  if (!orgId || !sessionId) {
    toastr.error("Error", "Organization ID and session ID are required");
    return;
  }

  axios.delete(`${API_URL}/organisations/${orgId}/leaked-sessions/${sessionId}`, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then((res) => {
      if (res.data.status === 200 || res.status === 200) {
        toastr.success("Success", res.data.userMessage || "Leaked session deleted successfully");
        if (callback) {
          callback();
        }
      } else {
        toastr.error("Error", res.data.userMessage || "Failed to delete leaked session");
      }
    })
    .catch((error) => {
      let errorMessage = "Failed to delete leaked session";

      if (error.response) {
        if (error.response.data?.userMessage) {
          errorMessage = error.response.data.userMessage;
        } else if (error.response.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.status === 400) {
          errorMessage = "Invalid request. Please try again.";
        } else if (error.response.status === 404) {
          errorMessage = "Leaked session not found.";
        } else if (error.response.status === 500) {
          errorMessage = "Server error. Please try again later.";
        }
      } else if (error.request) {
        errorMessage = "Network error. Please check your connection.";
      }

      toastr.error("Error", errorMessage);
      // console.error removed
    });
};

export const createManualLeakedSession = (orgId, sessionData, onSuccessCallback, dispatch) => {
  if (!orgId || !sessionData) {
    toastr.error("Error", "Organization ID and session data are required");
    return;
  }

  // Validate session data fields
  if (!sessionData.name || sessionData.name.trim() === "") {
    toastr.error("Error", "Session name is required");
    return;
  }

  if (!sessionData.val || sessionData.val.trim() === "") {
    toastr.error("Error", "Session value is required");
    return;
  }

  if (!sessionData.dom || sessionData.dom.trim() === "") {
    toastr.error("Error", "Domain is required");
    return;
  }

  if (!sessionData.fnd || sessionData.fnd.trim() === "") {
    toastr.error("Error", "Found date is required");
    return;
  }

  axios.post(`${API_URL}/leaked-sessions/${orgId}/manual-insert`, sessionData, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then((res) => {
      if (res.data.error === false) {
        toastr.success("Success", res.data.userMessage || "Leaked session added successfully");
        // Call success callback which includes clearing form and redirecting
        if (onSuccessCallback) {
          onSuccessCallback();
        }
      } else {
        toastr.error("Error", res.data.userMessage || "Failed to add leaked session");
      }
    })
    .catch((error) => {
      // Handle different types of errors
      let errorMessage = "Failed to add leaked session";

      if (error.response) {
        // Server responded with error status
        if (error.response.data?.userMessage) {
          errorMessage = error.response.data.userMessage;
        } else if (error.response.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.status === 400) {
          errorMessage = "Invalid data provided. Please check your input.";
        } else if (error.response.status === 404) {
          errorMessage = "Organization not found or endpoint unavailable.";
        } else if (error.response.status === 500) {
          errorMessage = "Server error. Please try again later.";
        }
      } else if (error.request) {
        // Request was made but no response received
        errorMessage = "Network error. Please check your connection.";
      }

      toastr.error("Error", errorMessage);
      // console.error removed
    });
};

export const createPostmanRecord = (orgId, postmanData, onSuccessCallback, dispatch, onErrorCallback) => {
  axios.post(`${API_URL}/postmanRecord/${orgId}/entry`, postmanData, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then((res) => {
      if (res.data.error === false) {
        toastr.success("Success", res.data.userMessage || "Postman record added successfully");
        // Call success callback which includes clearing form and redirecting
        if (onSuccessCallback) {
          onSuccessCallback();
        }
      } else {
        const errorMessage = res.data.userMessage || "Failed to add postman record";
        toastr.error("Error", errorMessage);
        if (onErrorCallback) {
          onErrorCallback({ message: errorMessage });
        }
      }
    })
    .catch((error) => {
      // Handle different types of errors
      let errorMessage = "Failed to add postman record";

      if (error.response) {
        // Server responded with error status
        if (error.response.data?.userMessage) {
          errorMessage = error.response.data.userMessage;
        } else if (error.response.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.status === 400) {
          errorMessage = "Invalid data provided. Please check your input.";
        } else if (error.response.status === 404) {
          errorMessage = "Organization not found or endpoint unavailable.";
        } else if (error.response.status === 500) {
          errorMessage = "Server error. Please try again later.";
        }
      } else if (error.request) {
        // Request was made but no response received
        errorMessage = "Network error. Please check your connection.";
      }

      toastr.error("Error", errorMessage);
      // console.error removed

      if (onErrorCallback) {
        onErrorCallback({ message: errorMessage });
      }
    });
};



